import { observer } from 'mobx-react-lite';
import React from 'react';
import { TabPanel } from 'react-tabs';
import { colors } from '../../../../../../../../colorVars';
import { modifySoftOrder } from '../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/modifySoftOrders';
import { useWebsocketStore } from '../../../../../../../../stores/websocketStore/websocketProvider';
import { EditableTableField } from '../../../../../../../atomic/inputs/editableTableField/EditableTableField';
import { Body3 } from '../../../../../../../atomic/text/Text';
import { IndividualPanelHeader } from '../IndividualPanelHeader';
import style from '../IndividualTacticStyle.module.css';

export const FlagTacticPanel = observer(
  // eslint-disable-next-line no-unused-vars
  ({ tradePlanId, addTab, ...rest }) => {
    const { tradePlanStore } = useWebsocketStore();
    const tacticId = tradePlanStore.tradePlans[tradePlanId].setupDetails['FLAG']?.tacticId ?? null;
    const softOrder = tradePlanStore.softOrdersById[tacticId] ?? null;
    const breakBy = softOrder?.value.tacticValue.breakBy ?? null;

    const updateSoftOrder = (type, value) => {
      modifySoftOrder({ softOrder, type, value });
    };

    if (!tacticId || !softOrder) return null;

    return (
      <TabPanel {...rest}>
        <div className={style.tableContainer}>
          <table className={style.table}>
            <IndividualPanelHeader />
            <tbody>
              <tr>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Break By
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <Body3
                    fontWeight={700}
                    color={colors.lightGrey}
                    margin="3px 3px 0 0"
                  >
                    $
                  </Body3>
                  <EditableTableField
                    bodySize={3}
                    initialValue={breakBy}
                    updateValue={(newValue) =>
                      updateSoftOrder('breakBy', newValue)
                    }
                    color={colors.lightGrey}
                    backgroundColor="inherit"
                  />
                </td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </TabPanel>
    );
  }
);

FlagTacticPanel.tabsRole = 'TabPanel';
